import { fetchAuthSession } from 'aws-amplify/auth'

/**
 * `signOut()`がCognitoの`/logout`へのフルページ遷移を伴うかどうかを返す。
 *
 * Amplifyはフェデレーションでサインインした場合だけ`/logout`へ遷移し、
 * パスワードログインの場合はトークンを破棄するだけで遷移しない。
 * 遷移する場合に`navigate()`でログイン画面へ動かすと、Cognito → Auth0 → ログイン画面の
 * リダイレクトが終わるまでの1〜2秒間ログイン画面が表示され続け、そのあと本物の
 * ログイン画面が読み込まれるため、ログイン画面がリロードされたように見えてしまう。
 *
 * 判定できない場合は`false`（遷移しない）を返す。誤って`true`にすると遷移も画面更新も
 * 起きずユーザーが取り残されるため、安全側に倒す。
 */
export const willRedirectOnSignOut = async (): Promise<boolean> => {
  // OAuthの設定が無い環境ではAmplifyがそもそもリダイレクトしない
  if (!import.meta.env.VITE_COGNITO_DOMAIN) {
    return false
  }

  try {
    const { tokens } = await fetchAuthSession()

    // フェデレーションでサインインした場合だけIDトークンに`identities`が含まれる
    return !!tokens?.idToken?.payload.identities
  } catch (_) {
    return false
  }
}
